import { Button } from "primereact/button";
import { AvaliadorPlantioType, ImovelType, PlanoType, STATUS } from "../../db/Orm";
import CadastroPlantio, { CadastroPlantioConfig } from "../dialogs/CadastroPlantio";
import { useState } from "react";
import Auth from "../../auth/Authenticator";
import { CardAvaliacaoPlantio } from "../dialogs/CardAvaliacaoPlantio";
import { DialogRequerimentoAntecipacao, RequerimentoFields } from "../dialogs/RequerimentoAntecipacao";
import { DialogTermoAntecipacao, TermoFields } from "../dialogs/TermoAntecipacao";
import CadastroControles from "../dialogs/CadastroControles";
import { VisualizacaoControles } from "../dialogs/VisualizacaoControles";
import { PlanTrabAntecipacao, PlanTrabFields } from "../dialogs/PlanTrabAntecipacao";

enum STATUS_ANTECIPACAO {
    CRIADO = 0,
    PLANTIO_CADASTRADO_PRODUTOR = 1,
    PLANTIO_REPROVADO_RT = 2,
    PLANTIO_APROVADO_RT = 3,
    PLANTIO_REPROVADO_AIBA = 4,
    PLANTIO_APROVADO_AIBA = 5,
    DOCUMENTOS_ASSINADOS = 6,
    INTEGRADO_SEI = 7,
    // CONTROLE_REPROVADO_AIBA = 8,
    // CONTROLE_ASSINADO_PRODUTOR = 9,
    // PLANO_APROVADO_ADAB = 10,
    // PLANO_REPROVADO_ADAB = 11,
    ESTADO_DESCONHECIDO = 12
}

enum CORES_STATUS {
    N = '',
    A = '#CFC',
    R = '#FCC',
    U = ''
}

type AntecipacaoProps = {
    antecipacao: PlanoType|null,
    propriedades: ImovelType[],
    carregarPlanos: ()=>Promise<void>|(()=>void)
}

export const estado = (antecipacao: PlanoType): STATUS_ANTECIPACAO => {
    // console.log('antecipacao', antecipacao)
    if (!antecipacao.plantios?.length) return STATUS_ANTECIPACAO.CRIADO
    if (antecipacao.aprovacao_rt_status === STATUS.NOVO) return STATUS_ANTECIPACAO.PLANTIO_CADASTRADO_PRODUTOR
    if (antecipacao.aprovacao_rt_status === STATUS.REPROVADO) return STATUS_ANTECIPACAO.PLANTIO_REPROVADO_RT
    if (antecipacao.aprovacao_rt_status === STATUS.APROVADO && antecipacao.aprovacao_aiba_status === STATUS.NOVO) return STATUS_ANTECIPACAO.PLANTIO_APROVADO_RT
    if (antecipacao.aprovacao_aiba_status === STATUS.REPROVADO) return STATUS_ANTECIPACAO.PLANTIO_REPROVADO_AIBA
    if (antecipacao.aprovacao_aiba_status === STATUS.APROVADO && !(antecipacao.requerimento_assinado_produtor && antecipacao.termo_assinado_produtor && antecipacao.controles_assinado_produtor)) return STATUS_ANTECIPACAO.PLANTIO_APROVADO_AIBA
    if (antecipacao.requerimento_assinado_produtor && antecipacao.termo_assinado_produtor && antecipacao.controles_assinado_produtor && !antecipacao.sei) return STATUS_ANTECIPACAO.DOCUMENTOS_ASSINADOS
    
    // if (antecipacao.controles_status !== STATUS.NOVO) {
    //     if (antecipacao.controles_status === STATUS.APROVADO)
    //         return STATUS_ANTECIPACAO.PLANO_APROVADO_ADAB
    //     return STATUS_ANTECIPACAO.PLANO_REPROVADO_ADAB
    // }
    // else if (antecipacao.controles_assinado_produtor)
    //     return STATUS_ANTECIPACAO.CONTROLE_ASSINADO_PRODUTOR
    // else if (antecipacao.controles_status_associacao !== STATUS.NOVO) {
    //     if (antecipacao.controles_status_associacao === STATUS.APROVADO)
    //         return STATUS_ANTECIPACAO.CONTROLE_APROVADO_AIBA
    //     return STATUS_ANTECIPACAO.CONTROLE_REPROVADO_AIBA
    // } else if (antecipacao.controles_doc)
    //     return STATUS_ANTECIPACAO.CONTROLE_CADASTRADO_RT
    // else if (antecipacao.requerimento_status !== STATUS.NOVO) {
    //     if (antecipacao.requerimento_status === STATUS.APROVADO)
    //         return STATUS_ANTECIPACAO.PLANTIO_APROVADO_AIBA
    //     return STATUS_ANTECIPACAO.PLANTIO_REPROVADO_AIBA
    // } else if (antecipacao.aprovacao_rt_status !== STATUS.NOVO) {
    //     if (antecipacao.aprovacao_rt_status === STATUS.APROVADO)
    //         return STATUS_ANTECIPACAO.PLANTIO_APROVADO_RT
    //     return STATUS_ANTECIPACAO.PLANTIO_REPROVADO_RT
    // } else if (antecipacao.aprovacao_rt) {
    //     return STATUS_ANTECIPACAO.PLANTIO_CADASTRADO_PRODUTOR
    // }
    // return STATUS_ANTECIPACAO.PLANO_REPROVADO_ADAB
    return STATUS_ANTECIPACAO.ESTADO_DESCONHECIDO
}

export const labelEstado = (antecipacao: PlanoType) => {
    switch (estado(antecipacao)) {
        case STATUS_ANTECIPACAO.CRIADO: return 'Criado'
        case STATUS_ANTECIPACAO.PLANTIO_CADASTRADO_PRODUTOR: return 'Plantio Cadastrado'
        case STATUS_ANTECIPACAO.PLANTIO_REPROVADO_RT: return 'Plantio Reprovado RT'
        case STATUS_ANTECIPACAO.PLANTIO_APROVADO_RT: return 'Plantio Aprovado RT'
        case STATUS_ANTECIPACAO.PLANTIO_REPROVADO_AIBA: return 'Plantio Reprovado AIBA'
        case STATUS_ANTECIPACAO.PLANTIO_APROVADO_AIBA: return 'Plantio Aprovado AIBA'
        case STATUS_ANTECIPACAO.DOCUMENTOS_ASSINADOS: return 'Documentos Assinados'
        // case STATUS_ANTECIPACAO.CONTROLE_APROVADO_AIBA: return 'Controle Aprovado AIBA'
        // case STATUS_ANTECIPACAO.CONTROLE_REPROVADO_AIBA: return 'Controle Reprovado AIBA'
        // case STATUS_ANTECIPACAO.CONTROLE_ASSINADO_PRODUTOR: return 'Assinado Produtor'
        // case STATUS_ANTECIPACAO.PLANO_APROVADO_ADAB: return 'Aprovado ADAB'
        // case STATUS_ANTECIPACAO.PLANO_REPROVADO_ADAB: return 'Reprovado ADAB'
        default: return 'ESTADO DESCONHECIDO'
    }
}

export const labelEstadoCompleto = (antecipacao: PlanoType) => {
    switch (estado(antecipacao)) {
        case STATUS_ANTECIPACAO.CRIADO: return 'Antecipação criada, aguardando cadastro de plantio pelo Produtor.'
        case STATUS_ANTECIPACAO.PLANTIO_CADASTRADO_PRODUTOR: return 'Plantio Cadastrado pelo Produtor, aguardando aprovação do Responsável Técnico'
        case STATUS_ANTECIPACAO.PLANTIO_REPROVADO_RT: return 'Plantio reprovado pelo Responsável Técnico, criar nova antecipação.'
        case STATUS_ANTECIPACAO.PLANTIO_APROVADO_RT: return 'Plantio aprovado pelo Responsável Técnico, aguardando aprovação da associação AIBA'
        case STATUS_ANTECIPACAO.PLANTIO_REPROVADO_AIBA: return 'Plantio reprovado pela associação AIBA'
        case STATUS_ANTECIPACAO.PLANTIO_APROVADO_AIBA: return 'Plantio aprovado pela associação AIBA, aguardando geração e assinaturas do Requerimento, Termo e Plano de Trabalho'
        case STATUS_ANTECIPACAO.DOCUMENTOS_ASSINADOS: return 'Plano de controle cadastrado pelo Responsável Técnico'
        // case STATUS_ANTECIPACAO.CONTROLE_APROVADO_AIBA: return 'Plano de controle aprovado AIBA pela associação AIBA'
        // case STATUS_ANTECIPACAO.CONTROLE_REPROVADO_AIBA: return 'Plano de controle reprovado AIBA pela associação AIBA'
        // case STATUS_ANTECIPACAO.CONTROLE_ASSINADO_PRODUTOR: return 'Termo e Plano assinados pelo Produtor'
        // case STATUS_ANTECIPACAO.PLANO_APROVADO_ADAB: return 'Termo e Plano aprovados e assinados pela agência ADAB'
        // case STATUS_ANTECIPACAO.PLANO_REPROVADO_ADAB: return 'Antecipação reprovada pela agência ADAB'
        default: return 'ESTADO DESCONHECIDO'
    }
}

const labelBotaoPlantio = (antecipacao: PlanoType) => {
    const status = estado(antecipacao)
    switch (status) {
        case STATUS_ANTECIPACAO.CRIADO:
            return 'Aguardando cadastro pelo Produtor'
        case STATUS_ANTECIPACAO.PLANTIO_CADASTRADO_PRODUTOR:
            return 'Aguardando aprovação do Responsável Técnico'
        case STATUS_ANTECIPACAO.PLANTIO_APROVADO_RT:
            return 'Aguardando aprovação da Associação (AIBA)'
        case STATUS_ANTECIPACAO.PLANTIO_REPROVADO_RT:
            return 'Plantio reprovado pelo Responsável Técnico'
        case STATUS_ANTECIPACAO.PLANTIO_REPROVADO_AIBA:
            return 'Plantio reprovado pela Associação (AIBA)'
        default:
            return 'Cadastro aprovado'

    }
}
const labelBotaoApAIBA = (antecipacao: PlanoType) => {
    if (estado(antecipacao) === STATUS_ANTECIPACAO.CRIADO) return ''
    switch(antecipacao.aprovacao_rt_status){
        case STATUS.NOVO:
            return 'Aguardando avaliação do RT'
        case STATUS.REPROVADO:
            return 'Plantios reprovados pelo RT'
        case STATUS.ATUALIZADO:
            return ''
    }
    switch(antecipacao.aprovacao_aiba_status){
        case STATUS.NOVO:
            return 'Aguardando aprovação'
        case STATUS.APROVADO:
            return 'Plantios aprovados pela AIBA'
        case STATUS.REPROVADO:
            return 'Plantios reprovados pela AIBA'
        default:
            return ''
    }
}
const labelBotaoReqDoc = (antecipacao: PlanoType)=>{
    if (estado(antecipacao) < STATUS_ANTECIPACAO.PLANTIO_APROVADO_AIBA) return ''
    if (!antecipacao.requerimento) return 'Aguardando geração do Requerimento'
    return 'Requerimento gerado'
}
const labelBotaoReqProd = (antecipacao: PlanoType)=>{
    if (estado(antecipacao) < STATUS_ANTECIPACAO.PLANTIO_APROVADO_AIBA) return ''
    if (!antecipacao.requerimento) return ''
    return antecipacao.requerimento_assinado_produtor ? 'Assinatura enviada' : 'Aguardando envio do Requerimento assinado'
}
const labelBotaoTerDoc = (antecipacao: PlanoType)=>{
    if (estado(antecipacao) < STATUS_ANTECIPACAO.PLANTIO_APROVADO_AIBA) return ''
    if (!antecipacao.termo) return 'Aguardando geração do Termo'
    return 'Termo gerado'
}
const labelBotaoTerAIBA = (antecipacao: PlanoType)=>{
    if (estado(antecipacao) < STATUS_ANTECIPACAO.PLANTIO_APROVADO_AIBA) return ''
    if (!antecipacao.termo) return ''
    return antecipacao.termo_assinado_aiba ? 'Assinatura AIBA enviada' : 'Aguardando envio do Termo assinado pela AIBA'
}
const labelBotaoTerProd = (antecipacao: PlanoType)=>{
    if (estado(antecipacao) < STATUS_ANTECIPACAO.PLANTIO_APROVADO_AIBA) return ''
    if (!antecipacao.termo || !antecipacao.termo_assinado_aiba) return ''
    return antecipacao.termo_assinado_produtor ? 'Assinatura do Produtor enviada' : 'Aguardando envio do Termo assinado pelo Produtor'
}
const labelBotaoControles = (antecipacao: PlanoType) => {
    if (estado(antecipacao) < STATUS_ANTECIPACAO.PLANTIO_APROVADO_AIBA) return ''
    const numeroControles = antecipacao.plantios?.reduce((acc, pl)=>acc + (pl.controles?.length || 0), 0) || 0
    return numeroControles === 0 ? 'Nenhum controle cadastrado' : `Número de controles cadastrados: ${numeroControles}`
}
const labelBotaoPlanTrab = (antecipacao: PlanoType)=>{
    if (estado(antecipacao) < STATUS_ANTECIPACAO.PLANTIO_APROVADO_AIBA) return ''
    const numeroControles = antecipacao.plantios?.reduce((acc, pl)=>acc + (pl.controles?.length || 0), 0) || 0
    if (numeroControles === 0) return 'Cadastre os controles antes de gerar este documento'
    return antecipacao.controles_doc ? 'Plano de Trabalho gerado' : 'Aguardando geração do Plano de Trabalho'
}
const labelBotaoPlanTrabRT = (antecipacao: PlanoType)=>{
    if (estado(antecipacao) < STATUS_ANTECIPACAO.PLANTIO_APROVADO_AIBA) return ''
    if (!antecipacao.controles_doc) return ''
    return antecipacao.controles_assinado_rt ? 'Assinatura do Responsável Técnico enviada' : 'Aguardando envio do Plano de Trabalho assinado pelo Responsável Técnico'
}
const labelBotaoPlanTrabAIBA = (antecipacao: PlanoType)=>{
    if (estado(antecipacao) < STATUS_ANTECIPACAO.PLANTIO_APROVADO_AIBA) return ''
    if (!antecipacao.controles_doc) return ''
    return antecipacao.controles_assinado_aiba ? 'Assinatura AIBA enviada' : 'Aguardando envio do Plano de Trabalho assinado pela AIBA'
}
const labelBotaoPlanTrabProd = (antecipacao: PlanoType)=>{
    if (estado(antecipacao) < STATUS_ANTECIPACAO.PLANTIO_APROVADO_AIBA) return ''
    if (!antecipacao.controles_doc || !antecipacao.controles_assinado_aiba) return ''
    return antecipacao.controles_assinado_produtor ? 'Assinatura do Produtor enviada' : 'Aguardando envio do Plano de Trabalho assinado pelo Produtor'
}
const CardAntecipacao = (props: AntecipacaoProps) => {
    const auth = Auth.useAuth()
    const isUserRT = (antecipacao: PlanoType) => {
        return auth.user?.id === antecipacao.responsavel_tecnico?.id
    }
    const labelBotaoApRT = (antecipacao: PlanoType) => {
        const status = estado(antecipacao)
        if (status === STATUS_ANTECIPACAO.CRIADO) return ''
        if (status === STATUS_ANTECIPACAO.PLANTIO_CADASTRADO_PRODUTOR) {
            return isUserRT(antecipacao) ? 'Aguardando aprovação' : 'Você não é o RT cadastrado para este plantio'
        }
        switch (antecipacao.aprovacao_rt_status){
            case STATUS.NOVO:
                return 'Aguardando aprovação'
            case STATUS.APROVADO:
                return 'Plantios aprovados pelo RT'
            case STATUS.REPROVADO:
                return 'Plantios reprovados pelo RT'
            default:
                return ''
        }
    }
    console.log('CardAntecipacao', props.antecipacao?.propriedade)
    console.log('antecipacao', props.antecipacao)
    const [avaliacaoPlantioVisible, setAvaliacaoPlantioVisible] = useState(false)
    const [avaliadorPlantio, setAvaliadorPlantio] = useState<AvaliadorPlantioType>('rt')
    const showAvaliacaoPlantio = (avaliador: AvaliadorPlantioType)=>{
        setAvaliacaoPlantioVisible(true)
        setAvaliadorPlantio(avaliador)
    }
    const [requerimentoAntecipacaoVisible, setRequerimentoAntecipacaoVisible] = useState(false)
    const [tipoRequerimento, setTipoRequerimento] = useState<RequerimentoFields>('requerimento')
    const showRequerimentoPlano = (reqTipo: RequerimentoFields)=>{
        setRequerimentoAntecipacaoVisible(true)
        setTipoRequerimento(reqTipo)
    }
    const [termoAntecipacaoVisible, setTermoAntecipacaoVisible] = useState(false)
    const [tipoTermo, setTipoTermo] = useState<TermoFields>('termo')
    const showTermoPlano = (termoTipo: TermoFields)=>{
        setTermoAntecipacaoVisible(true)
        setTipoTermo(termoTipo)
    }
    const [showPlantio, setShowPlantio] = useState(false)
    const [showControles, setShowControles] = useState(false)
    const [planTrabVisible, setPlanTrabVisible] = useState(false)
    const [tipoPlanTrab, setTipoPlanTrab] = useState<PlanTrabFields>('controles_doc')
    const showPlanTrab = (planTrabTipo: PlanTrabFields)=>{
        setPlanTrabVisible(true)
        setTipoPlanTrab(planTrabTipo)
    }
    const [showVisualizarControles, setShowVisualizarControles] = useState(false)
    return (
        props.antecipacao ?
            <>
                <div>
                    <table className='antecipacao-dados' >
                        <th>Imóvel</th>
                        <th>Safra</th>
                        <th>Status</th>
                        <tr>
                            <td>{props.antecipacao.propriedade?.nome}</td>
                            <td>{props.antecipacao.safra?.periodo}</td>
                            <td>{labelEstadoCompleto(props.antecipacao)}</td>
                        </tr>
                    </table>
                </div>
                <CadastroPlantio visible={showPlantio} setVisible={setShowPlantio}
                    propriedades={[props.antecipacao.propriedade]} propriedade={props.antecipacao.propriedade}
                    config={CadastroPlantioConfig.CADASTRO_PRODUTOR} plano={props.antecipacao} onCadastroSucesso={props.carregarPlanos}
                />
                <CardAvaliacaoPlantio visible={avaliacaoPlantioVisible} hide={()=>setAvaliacaoPlantioVisible(false)} antecipacao={props.antecipacao}
                    avaliador={avaliadorPlantio} carregarPlanos={props.carregarPlanos} />
                <DialogRequerimentoAntecipacao visible={requerimentoAntecipacaoVisible} hide={()=>setRequerimentoAntecipacaoVisible(false)}
                    antecipacao={props.antecipacao} carregarPlanos={props.carregarPlanos} requerimentoField={tipoRequerimento} />
                <DialogTermoAntecipacao visible={termoAntecipacaoVisible} hide={()=>setTermoAntecipacaoVisible(false)}
                    antecipacao={props.antecipacao} carregarPlanos={props.carregarPlanos} termoField={tipoTermo} />
                <CadastroControles propriedades={[props.antecipacao.propriedade]} visible={showControles} setVisible={setShowControles}
                    preSelectPlano={props.antecipacao} onCadastrar={props.carregarPlanos} />
                <VisualizacaoControles visible={showVisualizarControles} hide={()=>setShowVisualizarControles(false)} antecipacao={props.antecipacao}
                    carregarPlanos={props.carregarPlanos} />
                <PlanTrabAntecipacao visible={planTrabVisible} hide={()=>setPlanTrabVisible(false)} antecipacao={props.antecipacao}
                    carregarPlanos={props.carregarPlanos} planTrabField={tipoPlanTrab} />
                <div className='antecipacao-buttongrid' >
                    <div>
                        <Button label="Plantio" className="p-button-raised p-button-text"
                            style={{ backgroundColor: props.antecipacao.plantios?.length ? '#CFC' : '' }}
                            onClick={() => setShowPlantio(true)} disabled={!([STATUS_ANTECIPACAO.CRIADO, STATUS_ANTECIPACAO.PLANTIO_CADASTRADO_PRODUTOR].includes(estado(props.antecipacao)))}/>
                        <p>{labelBotaoPlantio(props.antecipacao)}</p>
                        <Button label="Aprovação RT" className="p-button-raised p-button-text"
                            style={{ backgroundColor: CORES_STATUS[props.antecipacao.aprovacao_rt_status] }}
                            disabled={estado(props.antecipacao) < STATUS_ANTECIPACAO.PLANTIO_CADASTRADO_PRODUTOR}
                            // disabled={estado(props.antecipacao)!==STATUS_ANTECIPACAO.PLANTIO_CADASTRADO_PRODUTOR || !isUserRT(props.antecipacao)}
                            onClick={()=>showAvaliacaoPlantio('rt')} />
                        <p>{labelBotaoApRT(props.antecipacao)}</p>
                        <Button label="Avaliação AIBA" className="p-button-raised p-button-text"
                            style={{ backgroundColor: CORES_STATUS[props.antecipacao.aprovacao_aiba_status] }}
                            disabled={props.antecipacao.aprovacao_rt_status !== STATUS.APROVADO}
                            onClick={()=>showAvaliacaoPlantio('aiba')} />
                        <p>{labelBotaoApAIBA(props.antecipacao)}</p>
                    </div>
                    <div>
                        <Button label='Requerimento' className="p-button-raised p-button-text" onClick={()=>showRequerimentoPlano('requerimento')}
                            style={{ backgroundColor: props.antecipacao.requerimento ? '#CFC' : '' }}
                            disabled={estado(props.antecipacao) < STATUS_ANTECIPACAO.PLANTIO_APROVADO_AIBA} />
                        <p>{labelBotaoReqDoc(props.antecipacao)}</p>
                        <Button label='Assinatura Produtor' className="p-button-raised p-button-text"
                            style={{ backgroundColor: props.antecipacao.requerimento_assinado_produtor ? '#CFC' : ''  }}
                            onClick={()=>showRequerimentoPlano('requerimento_assinado_produtor')} disabled={!props.antecipacao.requerimento} />
                        <p>{labelBotaoReqProd(props.antecipacao)}</p>
                    </div>
                    <div>
                        <Button label="Termo" className="p-button-raised p-button-text" onClick={()=>showTermoPlano('termo')}
                            style={{ backgroundColor: props.antecipacao.termo ? '#CFC' : '' }}
                            disabled={estado(props.antecipacao) < STATUS_ANTECIPACAO.PLANTIO_APROVADO_AIBA} />
                        <p>{labelBotaoTerDoc(props.antecipacao)}</p>
                        <Button label="Assinatura AIBA" className="p-button-raised p-button-text" onClick={()=>showTermoPlano('termo_assinado_aiba')}
                            style={{ backgroundColor: props.antecipacao.termo_assinado_aiba ? '#CFC' : '' }}
                            disabled={estado(props.antecipacao) < STATUS_ANTECIPACAO.PLANTIO_APROVADO_AIBA || !props.antecipacao.termo} />
                        <p>{labelBotaoTerAIBA(props.antecipacao)}</p>
                        <Button label="Assinatura Produtor" className="p-button-raised p-button-text" onClick={()=>showTermoPlano('termo_assinado_produtor')}
                            style={{ backgroundColor: props.antecipacao.termo_assinado_produtor ? '#CFC' : '' }}
                            disabled={estado(props.antecipacao) < STATUS_ANTECIPACAO.PLANTIO_APROVADO_AIBA || !props.antecipacao.termo || !props.antecipacao.termo_assinado_aiba} />
                        <p>{labelBotaoTerProd(props.antecipacao)}</p>
                    </div>
                    <div>
                        <Button label='Cadastrar Controles' className="p-button-raised p-button-text"
                            onClick={()=>setShowControles(true)} disabled={estado(props.antecipacao) < STATUS_ANTECIPACAO.PLANTIO_APROVADO_AIBA} />
                        <p>{labelBotaoControles(props.antecipacao)}</p>
                        <Button label='Visualizar Controles' className="p-button-raised p-button-text" onClick={()=>{setShowVisualizarControles(true)}}
                            disabled={estado(props.antecipacao) < STATUS_ANTECIPACAO.PLANTIO_APROVADO_AIBA} />
                    </div>
                    <div>
                        <Button label="Plano de Trabalho" className="p-button-raised p-button-text" onClick={()=>showPlanTrab('controles_doc')}
                            style={{ backgroundColor: props.antecipacao.controles_doc ? '#CFC' : '' }}
                            disabled={estado(props.antecipacao) < STATUS_ANTECIPACAO.PLANTIO_APROVADO_AIBA} />
                        <p>{labelBotaoPlanTrab(props.antecipacao)}</p>
                        <Button label="Assinatura RT" className="p-button-raised p-button-text"
                            onClick={()=>showPlanTrab('controles_assinado_rt')}
                            disabled={estado(props.antecipacao) < STATUS_ANTECIPACAO.PLANTIO_APROVADO_AIBA || !props.antecipacao.controles_doc} />
                        <p>{labelBotaoPlanTrabRT(props.antecipacao)}</p>
                        <Button label="Assinatura AIBA" className="p-button-raised p-button-text"
                            onClick={()=>showPlanTrab('controles_assinado_aiba')}
                            disabled={estado(props.antecipacao) < STATUS_ANTECIPACAO.PLANTIO_APROVADO_AIBA || !props.antecipacao.controles_assinado_rt} />
                        <p>{labelBotaoPlanTrabAIBA(props.antecipacao)}</p>
                        <Button label="Assinatura Produtor" className="p-button-raised p-button-text"
                            onClick={()=>showPlanTrab('controles_assinado_produtor')}
                            disabled={estado(props.antecipacao) < STATUS_ANTECIPACAO.PLANTIO_APROVADO_AIBA || !props.antecipacao.controles_assinado_aiba} />
                        <p>{labelBotaoPlanTrabProd(props.antecipacao)}</p>
                    </div>
                    <div>
                        <Button label='SEI' className="p-button-raised p-button-text" onClick={e=>alert('Em desenvolvimento')}
                            disabled={estado(props.antecipacao) < STATUS_ANTECIPACAO.DOCUMENTOS_ASSINADOS}
                         />
                        <p>label botao SEI</p>
                        <Button label='Termo' className="p-button-raised p-button-text" onClick={()=>showTermoPlano('termo_assinado_adab')}
                            disabled={estado(props.antecipacao) < STATUS_ANTECIPACAO.DOCUMENTOS_ASSINADOS}
                         />
                        <p>termo assinatura ADAB</p>
                        <Button label='Plano de Trabalho' className="p-button-raised p-button-text" onClick={()=>showPlanTrab('controles_assinado_adab')}
                            disabled={estado(props.antecipacao) < STATUS_ANTECIPACAO.DOCUMENTOS_ASSINADOS}
                         />
                        <p>plano de trabalho ADAB</p>
                    </div>
                    <div>
                        <Button label='Boleto' className="p-button-raised p-button-text" onClick={e=>alert('Em desenvolvimento')} />
                        <p>boleto</p>
                    </div>
                </div>
            </>
            :
            <div>
                Selecione uma antecipação
            </div>

    )
}
export default CardAntecipacao;